import { ChangeDetectorRef, Component, EventEmitter, Inject, OnDestroy, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment.prod';
import { DataService } from 'src/app/services/data.service';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import swal from 'sweetalert2';
import * as forge from 'node-forge';
import { LoaderService } from 'src/app/services/loader.service';
import Swal from 'sweetalert2';
import { title } from 'process';


@Component({
  selector: 'app-laptop-otpverifypopup',
  templateUrl: './laptop-otpverifypopup.component.html',
  styleUrls: ['./laptop-otpverifypopup.component.scss']
})
export class LaptopOtpverifypopupComponent implements OnInit {
  form: FormGroup;
  display: string;
  ResendOTP: boolean = false;
  enableVerify: boolean = true;
  showPopup: boolean = false;
  @Output() closePopup = new EventEmitter<boolean>();
  public publicUrl = environment.apipublicUrl;
  formData: any;
  formDataModified: any = {};
  otpValue: any;
  otpEnteredData: any;
  gender: any = [];
  base64Image: any;
  studentDataFromAadhar: any;
  studentData: boolean = true
  @ViewChild('otpInput') otpInput: any;
  studentResult: any;
  studentResultModified: any = {};
  publicKey: string = `-----BEGIN PUBLIC KEY-----
  MIIBITANBgkqhkiG9w0BAQEFAAOCAQ4AMIIBCQKCAQB4vticl4+Wxvhi39+YL+Ui
vwPHnD+OnzjniUb+U1qeY8VnCvGXjZsZzSq6P3vNPIpnPtlP0xUTeIsOvFzDa8W5
OuV3YIwPChPSA71Ng4+j1BqR8tNTpXNljAyk4HFvhS8TOX/vJ3WletwidzY3SNG1
pYkh1S5rlWHlin42O+uO7k2HG8Sup5hSGz2om3beNVoFHYLchLt+E5YhUGmUj5u1
yB+tpboqGZkWSp+W394BwlJdq6Uoo9GGRUYRfSYgxoHKSjOaEvtmxaEsB7nehOP7
Hj5N7em8bHsLQrtdC4xfkGzJMnR3nCuU80qIH1dcDtK3IfqfSD8wbTUyYlgdKrld
AgMBAAE=
  -----END PUBLIC KEY-----`;
  datamismatched: boolean;
  otpTimerRef:any;
  page: boolean;
  showOtppopup: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private dataService: DataService,
    private toaster: ToastrService,
    public translate: TranslateService,
    private httpClient: HttpClient,
    public loaderService: LoaderService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<LaptopOtpverifypopupComponent>,
    private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public dataRecievedToAdd: any,
  ) {
  }

  ngOnInit() {
    debugger
    this.formData = this.dataRecievedToAdd.studentResult;
    localStorage.setItem("studentForm", JSON.stringify(this.dataRecievedToAdd.studentResult));

    if (this.dataRecievedToAdd?.studentResult) {
      this.getOtp()
    }
    // this.otpEnteredData = this.dataRecievedToAdd.otpResult;
    // this.studentResult = this.dataRecievedToAdd?.studentResult;
    // this.studentResult.name.trim();
    this.initializeValidators();
    debugger


    // if (this.formData?.dateOfBirth) {
    //   // this.formDataModified.dateOfBirth = moment(new Date(this.formData.dateOfBirth)).format('YYYY')
    //   this.formDataModified.dateOfBirth = moment(new Date(this.formData.dateOfBirth)).format('DD-MM-YYYY');
    // }
    // if (this.studentResult?.dateOfBirth) {
    //   // this.studentResultModified.dateOfBirth = moment(new Date(this.formData.dateOfBirth)).format('YYYY');
    //   this.studentResultModified.dateOfBirth = moment(new Date(this.formData.dateOfBirth)).format('DD-MM-YYYY')
    // }
    // if (this.formData && this.formData.dateOfBirth) {
    //   debugger
    //   this.formDataModified.dateOfBirth = this.formatDate1(this.formData.dateOfBirth);
    // }

    // if (this.studentResult && this.studentResult.dateOfBirth) {
    //   this.studentResultModified.dateOfBirth = this.formatDate(this.studentResult.dateOfBirth);
    // }
    // if (this.formData?.genderId) {
    //   this.formDataModified.genderId = this.formData.genderId === 1 ? 'M' : this.formData.genderId === 2 ? 'F' : 'T';
    // }
    // if (this.studentResult?.genderId) {
    //   this.studentResultModified.genderId = this.studentResult.genderId === 1 ? 'M' : this.studentResult.genderId === 2 ? 'F' : 'T';
    // }
    // this.getOtp();
    // this.httpClient.get("assets/json/image-base64.json").subscribe(data => {
    //   debugger
    //   let res: any = data;
    //   res.address = res.house + ', ' + res.street + ', ' + res.landMark + ', ' + res.village + ', ' +
    //     res.district + ' - ' + res.pinCode + ', ' + res.state + ', ' + res.country + '.';
    //   this.studentDataFromAadhar = res;
    //   this.studentData = true;
    //   this.base64Image = 'data:image/jpg;base64,' + res.photoBase64String;
    // })

  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit' as const,
      month: '2-digit' as const,
      year: 'numeric' as const
    };
    return new Intl.DateTimeFormat('en-GB', options).format(date);
    // return dateString.replace(/\//g, '-'); 

  }

  formatDate1(dateString: string) {
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;

  }


  initializeValidators() {
    this.form = this.formBuilder.group({
      otp: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
    });
  }

  getOtp() {
    var rsa = forge.pki.publicKeyFromPem(this.publicKey);
    const aadhaarNo = this.dataRecievedToAdd?.studentResult?.replace(/\s+/g, '')
    var encryptedAadhar = window.btoa(rsa.encrypt(aadhaarNo));

    let data = {
      aadhaarNo:encryptedAadhar,
      isResend: true
    }
    this.dataService.getOtplaptopScheme(data, true).subscribe(res => {
      debugger
      if (res && res.status) {
        this.showOtppopup = false
        this.toaster.success('OTP Sent Successfully!!!', 'UMIS');
        this.timer(res.otpTimeout);
        this.otpEnteredData = res;
      } else {
        this.toaster.error(res.message);
      }
    });
  }

  checkUser() {
    this.showOtppopup = true;
    this.getOtp()
    this.timer(1);

  }

  onOtpChange(event) {
    debugger
    console.log('otp----', event);
    this.form.controls['otp'].setValue(event);
    this.otpValue = this.form.value.otp;
    if (this.form.value.otp.length === 6) {
      this.enableVerify = false;
    } else {
      this.enableVerify = true;
      this.form.controls['otp'].markAsTouched();
    }
  }

  isInput(event) {
    debugger
    if (this.form.value.otp.length === 6 && this.form.controls['validationId'].valid) {
      this.enableVerify = false;
    } else {
      this.enableVerify = true;
      // this.form.controls['validationId'].markAsTouched();
    }
  }

timer(minute: number) {
  let seconds = minute * 60;

  this.otpTimerRef = setInterval(() => {
    if (seconds > 0) {
      seconds--;

      const m = Math.floor(seconds / 60);
      const s = seconds % 60;

      this.display =
        `${m < 10 ? '0' + m : m}:${s < 10 ? '0' + s : s}`;
    }

    if (seconds <= 0) {
      clearInterval(this.otpTimerRef);
      this.ResendOTP = true;
    }

  }, 1000);
}


  sendData() {
    this.otpEnteredData;  
     this.showOtppopup = true;   
    console.log("otp", this.otpEnteredData);
    if (this.form.invalid) {
      this.form.markAllAsTouched();
    } else {
      var rsa = forge.pki.publicKeyFromPem(this.publicKey);
      const aadhaarNo = this.dataRecievedToAdd?.studentResult?.replace(/\s+/g, '')
      var encryptedAadhar = window.btoa(rsa.encrypt(aadhaarNo));

      var rsa = forge.pki.publicKeyFromPem(this.publicKey);
      var encryptedOtp = window.btoa(rsa.encrypt(this.otpValue));

      let payload = {
        aadhaarNo: encryptedAadhar,
        transactionId: this.otpEnteredData.transactionId,
        otpValue: encryptedOtp,
      }
      this.dataService.aadhaarVerificationlaptopScheme(payload).subscribe((res) => {
        if (res?.value?.isSuccess) {
          this.showOtppopup = false;   
          this.closeAadharPopupfunc(); 
        } else {
          this.toaster.error(res?.value?.errorMessage);
          }
      })
    }
  }

  // checkDateFormat(input: string): string {
  //   const yearPattern = /^\d{4}$/;
  //   const datePattern = /^\d{2}-\d{2}-\d{4}$/;
  //   if (yearPattern.test(input)) {
  //     this.formDataModified.dateOfBirth = moment(new Date(this.formData.dateOfBirth)).format('YYYY')
  //     this.studentResultModified.dateOfBirth = moment(new Date(this.formData.dateOfBirth)).format('YYYY');
  //   } else if (datePattern.test(input)) {
  //     this.formDataModified.dateOfBirth = moment(new Date(this.formData.dateOfBirth)).format('DD-MM-YYYY');
  //     this.studentResultModified.dateOfBirth = moment(new Date(this.formData.dateOfBirth)).format('DD-MM-YYYY');
  //   } else {
  //     return "Invalid format";
  //   }
  // }

  checkDateFormat(input: string): string {
    const yearPattern = /^\d{4}$/;
    const datePattern = /^\d{2}-\d{2}-\d{4}$/;

    if (yearPattern.test(input)) {
      const year = input; // The input is a valid year
      // this.formDataModified.dateOfBirth = year;
      this.studentResultModified.dateOfBirth = year;
    } else if (datePattern.test(input)) {
      const [day, month, year] = input.split('-');
      // Create a date object with the provided day, month, and year
      const formattedDate = `${day}-${month}-${year}`; // Convert to YYYY-MM-DD for consistency
      const [day1, month1, year1] = this.formData.dateOfBirth.split('/');
      // Create a date object with the provided day, month, and year
      const formattedDate1 = `${day1}-${month1}-${year1}`; // Convert to YYYY-MM-DD for consistency

      // this.formDataModified.dateOfBirth = formattedDate1;
      this.studentResultModified.dateOfBirth = formattedDate;
    } else {
      return "Invalid format";
    }
  }

  onCorrectData() {
    var rsa = forge.pki.publicKeyFromPem(this.publicKey);
    var encryptedAadhar = window.btoa(rsa.encrypt(this.formData.aadhaarNumber));

    let payload = {
      id: this.formData.id,
      aadhaarNo: encryptedAadhar,
      verificationStatus: true,
      imageBase64String: this.studentDataFromAadhar.photoBase64String,
      IsEKYCDoneByStudent: false,
      name: this.studentDataFromAadhar.name,
      dob: this.formData?.dateOfBirth
    }
    if (payload.id == 0) {
      this.dialogRef.close(this.studentDataFromAadhar);
    } else {
      if (this.formData.id !== 0) {
        if (this.studentResult.name !== this.studentDataFromAadhar.name || this.studentResultModified.genderId !== this.studentDataFromAadhar.gender
          || this.studentResultModified.dateOfBirth !== this.studentDataFromAadhar.dob) {
          this.openSwalConfirmation(payload, true); //Miss Matched
        } else {
          this.confirmApiCall(payload);
        }
      } else {
        if (this.formData.name === this.studentDataFromAadhar.name && this.formDataModified.genderId === this.studentDataFromAadhar.gender
          && this.formDataModified.dateOfBirth === this.studentDataFromAadhar.dob) {
          // this.dialogRef.close(payload);
          this.openSwalConfirmation(payload, false); //Not Miss Matched
        }
        else if (!this.formData.name || !this.formData.dateOfBirth || !this.formData.genderId) {
          // this.dialogRef.close(payload);
          this.openSwalConfirmation(payload, false); //Not Miss Matched
        }
        else {
          this.openSwalConfirmation(payload, true); //Miss Matched
        }
      }
    }
  }

  confirmApiCall(payload) {
    this.dataService.studentAadharVerification(payload).subscribe((res) => {
      if (res && res.isSuccess) {
        this.toaster.success('Validated Successfully!!!', 'UMIS');
        this.openSwalConfirmation(payload, false); //Not Miss Matched
        // this.dialogRef.close(payload);
      } else {
        this.toaster.error(res.htmlFormattedFailures);
      }
    })
  }

  openSwalConfirmation(payload, isMismatchData) {
    debugger
    if (isMismatchData) {
      let name, gender, dob, misMatched;
      if (this.formData.id === 0) {
        this.formData.name === this.studentDataFromAadhar.name ? name = true : name = false;
        this.formDataModified.genderId === this.studentDataFromAadhar.gender ? gender = true : gender = false;
        this.formDataModified.dateOfBirth === this.studentDataFromAadhar.dob ? dob = true : dob = false;
      }
      else {
        this.studentResult.name === this.studentDataFromAadhar.name ? name = true : name = false;
        this.studentResultModified.genderId === this.studentDataFromAadhar.gender ? gender = true : gender = false;
        this.studentResultModified.dateOfBirth === this.studentDataFromAadhar.dob ? dob = true : dob = false;
      }
      misMatched = (!name && !gender && !dob) ? "Name, Gender and Date of Birth" :
        (!name && !gender && dob) ? "Name and Gender" :
          (!name && gender && !dob) ? "Name and Date of Birth" :
            (name && !gender && !dob) ? "Gender and Date of Birth" :
              (!name && gender && dob) ? "Name" :
                (name && !gender && dob) ? "Gender" :
                  (name && gender && !dob) ? "Date of Birth" : ""

      // const title = 'Data Mismatch';
      // const Yes = this.translate.instant('Yes');
      // const No = this.translate.instant('No');
      // swal.fire({
      //   title,
      //   // html: `<p style="text-transform:initial;">Please be aware that there is a VARIANCE in the <strong>${misMatched}</strong> between the "Data from UMIS" and "Data from Aadhaar". Kindly confirm that you wish to still CONFIRM and proceed further.</p>`,
      //   html: `<p style="text-transform:initial;">Please validate the correct Aadhaar or check the UIDAI portal for Aadhaar detail corrections.</p>`,
      //   icon: 'warning',
      //   // showCancelButton: true,
      //   showCancelButton: false,
      //   confirmButtonColor: '#3085d6',
      //   cancelButtonColor: '#d33',
      //   allowOutsideClick: false,
      //   // confirmButtonText: Yes,
      //   // cancelButtonText: No,
      //   confirmButtonText: "Close",
      // }).then((result) => {
      debugger
      this.dialogRef.close(false);
      // if (result.isConfirmed) {
      //   if (this.formData.id === 0) {
      //     this.dialogRef.close(payload);
      //   } else {
      //     this.confirmApiCall(payload);
      //   }
      // }
      // })
    } else {
      // const title = 'Validated';
      // const Yes = this.translate.instant('Yes');
      // const No = this.translate.instant('No');
      // swal.fire({
      //   title,
      //   html: `<p style="text-transform:initial;">Aadhaar Validated Successfully!!!.</p>`,
      //   icon: 'success',
      //   showCancelButton: false,
      //   confirmButtonColor: '#3085d6',
      //   cancelButtonColor: '#d33',
      //   allowOutsideClick: false,
      //   confirmButtonText: "Close",
      // }).then((result) => {
      this.dialogRef.close(payload);
      // })
    }
  }

  studentImage(imagePath: any) {
    debugger
    let src = environment.imageBaseUrl + "" + imagePath.studentImagePath;
  }

  closeAadharPopup() {
    // this.closePopup.emit(true);
    this.dialogRef.close(false);

}
 closeAadharPopupfunc() {
    this.dialogRef.close(true);

}



  }

